<script>
import ElImage from 'element-ui/packages/image/src/main'

export default {
  name: 'ElImage',
  extends: ElImage,
  beforeDestroy () {
    // 图片随上层弹窗销毁时，同样恢复预览开启前的 body 滚动状态。
    if (this.showViewer) this.closeViewer()
  },
  render (h) {
    const vnode = ElImage.render.call(this, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-image']
    return vnode
  }
}
</script>
